import { Component, OnInit } from '@angular/core';
import { MappingSuggestionService } from '../../../../Services/TemplateMatching/mappingSuggestion.service';

@Component({
    selector: 'llm-response-cache',
    templateUrl: 'llmResponseCache.component.html',
    styleUrls: ['llmResponseCache.component.css'],
    standalone: false
})
export class LlmResponseCacheComponent implements OnInit {
    public entries: number = null;
    public busy = false;
    public lastRemoved: number = null;

    constructor(private mappingSuggestionService: MappingSuggestionService) {
    }

    ngOnInit(): void {
        this.load();
    }

    public async clear(): Promise<void> {
        this.busy = true;
        try {
            this.lastRemoved = await this.mappingSuggestionService.clearResponseCache();
            await this.load();
        } finally {
            this.busy = false;
        }
    }

    private async load(): Promise<void> {
        this.entries = await this.mappingSuggestionService.responseCacheSize();
    }
}
